import { List, Map, Record } from 'immutable';

const CompanyRecord = Record({
    activeSubscription: {},
    activeSyndicationCount: 0,
    balance: Map({
        available: 0,
        held: 0,
        pending: 0,
    }),
    boostsUsedThisPeriod: 0,
    campaignCount: 0,
    campaigns: List([]),
    canRebate: false,
    cardBrand: null,
    cardLastFour: null,
    costPerRebate: 0,
    flags: List([]),
    hasCard: null,
    id: null,
    isSubscribed: null,
    metadata: Map({}),
    name: '',
    remainingBoosts: 0,
    remainingKeywords: 0,
    remainingVideoShorts: 0,
    stripeId: null,
    trialEndsAt: null,
    unusedFeatures: 0,
    users: List([]),
});

function getHasBetaAccess() {
    return this.getIn(['metadata', 'hasBetaAccess'], false);
}

CompanyRecord.prototype.getHasBetaAccess = getHasBetaAccess;

export default CompanyRecord;



// WEBPACK FOOTER //
// ./src/records/company.js